import React from "react";
import PropTypes from "prop-types";
import { Redirect } from 'react-router-dom';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import changePasswordStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Clearfix from "components/Clearfix/Clearfix.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";

import Icon from "@material-ui/core/Icon";
import ConfirmDialog from 'customs/components/ConfirmDialog';

import { connect } from 'react-redux';
import { doFetchUserDetails, doUpdateProfile } from '../../store/actions/authActions';

import AuthService from 'customs/auth/AuthService';
import validations from "customs/helpers/validations";
import helpers from "customs/helpers/helpers";

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tr: false,
      confirmModal: false,
      confirmModalTitle: '',
      old_password: "",
      confirm_password: "",
      new_password: ""
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }
  
  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value, [event.target.id + '_valid']: "" });
  }

  componentDidMount () {
    if (!this.props.me) {
      helpers.showLoading();
      this.props.doFetchUserDetails({ ...this.props });
    }
  }

  handleUpdateProfileClick () {
    let cont = true;
    const is_valid_password = validations.validatePassword(this.state.new_password);
    const is_confirm_valid_password = validations.validatePassword(this.state.confirm_password);

    if (!is_valid_password) {
      cont = false;
      this.setState({ "new_password_valid": "error", "new_password_error": validations.passwordErrorMsg() });
    } else {
      this.setState({"new_password_valid" : "", "new_password_error": ""});
    }

    if (!is_confirm_valid_password) {
      cont = false;
      this.setState({ "confirm_password_valid": "error", "confirm_password_error": validations.passwordErrorMsg() });
    } else {
      this.setState({"confirm_password_valid" : "", "confirm_password_error": ""});
    }

    if (is_valid_password && is_confirm_valid_password && this.state.new_password !== this.state.confirm_password) {
      cont = false;
      this.setState({ "confirm_password_valid": "error", "confirm_password_error": "The password confirmation does not match" });
    }

    if (cont) {
      var x = [];
      x['confirmModal'] = true;
      this.setState({...x, 'confirmModalTitle': 'Change password'});
    }
  }

  doChangePasswordClick() {
    helpers.showLoading();
    this.handleClose("confirmModal");

    let me = {};
    me['name'] = this.props.me.name;
    me['email'] = this.props.me.email;
    me['password'] = this.state.new_password;
    me['password_confirmation'] = this.state.confirm_password;
    me['phone'] = this.props.me.phone;
    if (this.props.me.address1) me['address1'] = this.props.me.address1;
    if (this.props.me.address2) me['address2'] = this.props.me.address2;
    if (this.props.me.city) me['city'] = this.props.me.city;
    if (this.props.me.state) me['state'] = this.props.me.state;
    if (this.props.me.country) me['country'] = this.props.me.country;
    if (this.props.me.postal_code) me['postal_code'] = this.props.me.postal_code;

    this.props.doUpdateProfile(me, { ...this.props });
  }

  render() {
    const authService = new AuthService(this.state, this.props);
    if (!authService.getToken())
      return (<div><Redirect to="/auth/login"/></div>);

    let new_password_valid = this.state.new_password_valid;
    let new_password_error = this.state.new_password_valid === "error" && this.state.new_password
      ? (this.state.new_password_error ? this.state.new_password_error : validations.passwordErrorMsg()) : undefined;
    let confirm_password_valid = this.state.confirm_password_valid;
    let confirm_password_error = this.state.confirm_password_valid === "error" && this.state.confirm_password
      ? (this.state.confirm_password_error ? this.state.confirm_password_error : validations.passwordErrorMsg()) : undefined;

    const profileUpdated = this.props.auth && this.props.auth.authMessage ? this.props.auth.authMessage : '';
    if (profileUpdated) {
     this.props.auth.authMessage = '';
      setTimeout( function() {
        this.setState({profileUpdated,});
        if (profileUpdated === 'Profile Updated')
          this.setState({new_password: "", confirm_password: ""});
        helpers.hideLoading();
      }.bind(this), 100 );
    }

    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={6}>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <Icon className={classes.inputAdornmentIcon}>
                    lock_outline
                  </Icon>
                </CardIcon>
              </CardHeader>
              {
                this.state.profileUpdated
                  ? <CardBody style={{paddingBottom:'0px'}}>
                    <h4 className={classes.textCenter} id="reset_password_status" style={{color: this.state.profileUpdated === 'Profile Updated' ? '#4caf50' : 'red', marginBottom:'0px', paddingBottom:'0px'}}>
                      {this.state.profileUpdated === 'Profile Updated' ? "Password changed" : this.state.profileUpdated}
                    </h4>
                    </CardBody>
                  : ''
              }
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      success={new_password_valid === "success"}
                      error={new_password_valid === "error"}
                      labelText="New password"
                      id="new_password"
                      formControlProps={{
                        fullWidth: true
                      }}
                      helperText={ new_password_error }
                      inputProps={{
                        type: "password",
                        onChange: this.handleChange,
                        value: this.state.new_password
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      success={confirm_password_valid === "success"}
                      error={confirm_password_valid === "error"}
                      labelText="Confirm password"
                      id="confirm_password"
                      formControlProps={{
                        fullWidth: true
                      }}
                      helperText={ confirm_password_error }
                      inputProps={{
                        type: "password",
                        onChange: this.handleChange,
                        value: this.state.confirm_password
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <Button color="primary" className={classes.updateProfileButton} onClick={() => this.handleUpdateProfileClick("confirmModal")}>
                  Change Password
                </Button>
                <Clearfix />
              </CardBody>
            </Card>
          </GridItem>
          <ConfirmDialog
            confirmModal={this.state.confirmModal}
            confirmModalTitle={this.state.confirmModalTitle}
            onClose={() => this.handleClose("confirmModal")} 
            onYesClick={() => this.doChangePasswordClick()} />
        </GridContainer>
      </div>
    );
  }
}

ChangePassword.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => {
  helpers.hideLoading();
  return {
    auth: state.auth.data,
    me: state.auth.me,
    force_render: Math.random(),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    doFetchUserDetails: (props) => dispatch(doFetchUserDetails(props)),
    doUpdateProfile: (params, props) => dispatch(doUpdateProfile(params, props))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(changePasswordStyle)(ChangePassword));
